import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withModifiers as _withModifiers, withKeys as _withKeys, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, withCtx as _withCtx, vShow as _vShow, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "page-wrap" }
const _hoisted_2 = { class: "page-bar-sticky" }
const _hoisted_3 = { class: "page-bar page-bar-toggles-wrap" }
const _hoisted_4 = {
  class: "page-bar-toggles forge-tabs",
  role: "tablist"
}
const _hoisted_5 = ["aria-selected"]
const _hoisted_6 = ["aria-selected"]
const _hoisted_7 = { key: 0 }
const _hoisted_8 = ["aria-selected"]
const _hoisted_9 = { class: "ai-hub" }
const _hoisted_10 = {
  class: "fs-start",
  "aria-labelledby": "fs-start-title"
}
const _hoisted_11 = { class: "fs-box" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = {
  key: 0,
  class: "fs-error",
  role: "alert"
}
const _hoisted_14 = {
  key: 1,
  class: "fs-note",
  "aria-live": "polite"
}
const _hoisted_15 = { class: "fs-menu" }
const _hoisted_16 = { class: "fs-group" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = {
  key: 0,
  class: "fs-group"
}
const _hoisted_19 = ["onClick"]
const _hoisted_20 = {
  key: 0,
  id: "captures",
  class: "ai-drafts"
}
const _hoisted_21 = ["data-job-id"]
const _hoisted_22 = { class: "ai-drafts-name" }
const _hoisted_23 = {
  key: 0,
  class: "ai-drafts-sub"
}
const _hoisted_24 = {
  key: 1,
  class: "ai-drafts-sub"
}
const _hoisted_25 = { class: "ai-drafts-date" }
const _hoisted_26 = ["title"]
const _hoisted_27 = {
  key: 1,
  class: "ai-voice",
  "aria-labelledby": "ai-voice-title"
}
const _hoisted_28 = { key: 0 }
const _hoisted_29 = ["disabled"]
const _hoisted_30 = { key: 1 }
const _hoisted_31 = {
  key: 2,
  role: "status",
  class: "ai-voice-note"
}
const _hoisted_32 = { class: "fh-card" }
const _hoisted_33 = {
  viewBox: "0 0 72 72",
  "aria-hidden": "true"
}
const _hoisted_34 = ["stroke-dasharray"]
const _hoisted_35 = {
  key: 1,
  class: "fh-ring fh-ring-none"
}
const _hoisted_36 = { class: "fh-meta" }
const _hoisted_37 = { class: "fh-score" }
const _hoisted_38 = {
  key: 0,
  class: "fh-proj"
}
const _hoisted_39 = { class: "fh-sub" }
const _hoisted_40 = {
  key: 1,
  class: "fh-sub"
}
const _hoisted_41 = { class: "fh-actions" }
const _hoisted_42 = ["title"]
const _hoisted_43 = {
  key: 5,
  class: "ai-confirm"
}
const _hoisted_44 = { class: "ai-confirm-text" }
const _hoisted_45 = { class: "ai-confirm-est" }
const _hoisted_46 = {
  key: 2,
  class: "ai-usage-note",
  title: "Estimated Anthropic API cost this month at list pricing"
}
const _hoisted_47 = {
  key: 0,
  class: "ft-team",
  "aria-labelledby": "ft-team-title"
}
const _hoisted_48 = { class: "ft-team-h" }
const _hoisted_49 = { id: "ft-team-title" }
const _hoisted_50 = { class: "ft-team-count" }
const _hoisted_51 = {
  key: 0,
  class: "ai-run-error"
}
const _hoisted_52 = { class: "ft-team-main" }
const _hoisted_53 = { class: "ft-team-node" }
const _hoisted_54 = { key: 1 }
const _hoisted_55 = ["title"]
const _hoisted_56 = {
  key: 3,
  class: "ai-draft-flag"
}
const _hoisted_57 = {
  key: 4,
  class: "ai-draft-flag"
}
const _hoisted_58 = { class: "ft-team-text" }
const _hoisted_59 = { class: "ft-team-by" }
const _hoisted_60 = { class: "ft-team-acts" }
const _hoisted_61 = ["onClick"]
const _hoisted_62 = {
  key: 1,
  class: "ft-team-na"
}
const _hoisted_63 = ["onClick"]
const _hoisted_64 = {
  key: 2,
  class: "ai-progress"
}
const _hoisted_65 = { class: "ai-progress-label" }
const _hoisted_66 = { class: "ai-progress-track" }
const _hoisted_67 = {
  key: 3,
  class: "ai-run-error"
}
const _hoisted_68 = {
  key: 4,
  class: "ai-empty"
}
const _hoisted_69 = {
  key: 5,
  class: "fh-tools"
}
const _hoisted_70 = { class: "ai-search" }
const _hoisted_71 = {
  key: 0,
  class: "ai-search-count"
}
const _hoisted_72 = { class: "fh-filter" }
const _hoisted_73 = {
  key: 6,
  class: "ai-empty"
}
const _hoisted_74 = { key: 0 }
const _hoisted_75 = { key: 1 }
const _hoisted_76 = ["onClick"]
const _hoisted_77 = { class: "fh-card-main" }
const _hoisted_78 = { class: "ai-card-name" }
const _hoisted_79 = {
  key: 0,
  class: "ai-draft-flag"
}
const _hoisted_80 = { class: "fh-card-meta" }
const _hoisted_81 = {
  key: 0,
  class: "fh-owner"
}
const _hoisted_82 = ["title"]
const _hoisted_83 = {
  key: 0,
  class: "fh-detail"
}
const _hoisted_84 = { class: "fh-summary" }
const _hoisted_85 = { class: "fh-issues" }
const _hoisted_86 = ["title"]
const _hoisted_87 = {
  key: 0,
  class: "fh-rec"
}
const _hoisted_88 = { class: "fh-detail-foot" }
const _hoisted_89 = {
  key: 0,
  class: "fh-foot-note"
}
const _hoisted_90 = ["onClick"]
const _hoisted_91 = ["onClick"]
const _hoisted_92 = {
  key: 0,
  class: "fh-fix"
}
const _hoisted_93 = {
  key: 0,
  class: "ai-detail-lift"
}
const _hoisted_94 = { key: 1 }
const _hoisted_95 = { class: "ai-card-actions" }
const _hoisted_96 = ["onClick"]
const _hoisted_97 = { class: "fx-layout" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ai_create_node = _resolveComponent("ai-create-node")!
  const _component_forge_team = _resolveComponent("forge-team")!
  const _component_forge_notetaker = _resolveComponent("forge-notetaker")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_company_health = _resolveComponent("company-health")!
  const _component_forge_suggestion_draft = _resolveComponent("forge-suggestion-draft")!
  const _component_forge_compare = _resolveComponent("forge-compare")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[24] || (_cache[24] = _createElementVNode("div", { class: "page-bar" }, [
        _createElementVNode("div", null, [
          _createElementVNode("div", { class: "page-bar-sub" }, "AI"),
          _createElementVNode("div", { class: "page-bar-main" }, "The Forge")
        ])
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", {
            role: "tab",
            "aria-selected": _ctx.tab == 'make',
            class: _normalizeClass(_ctx.tab == 'make' ? 'page-bar-toggle-s' : ''),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setTab('make')))
          }, [...(_cache[21] || (_cache[21] = [
            _createElementVNode("svg", {
              xmlns: "http://www.w3.org/2000/svg",
              viewBox: "0 0 24 24",
              fill: "currentColor"
            }, [
              _createElementVNode("path", { d: "M10 2l1.8 5.2L17 9l-5.2 1.8L10 16l-1.8-5.2L3 9l5.2-1.8zM18 13l.9 2.6 2.6.9-2.6.9L18 20l-.9-2.6-2.6-.9 2.6-.9zM18 2l.6 1.9 1.9.6-1.9.6L18 7l-.6-1.9-1.9-.6 1.9-.6z" })
            ], -1),
            _createElementVNode("em", { class: "ft-label" }, [
              _createTextVNode("Make"),
              _createElementVNode("i", { class: "ft-long" }, " something")
            ], -1)
          ]))], 10, _hoisted_5),
          _createElementVNode("div", {
            role: "tab",
            "aria-selected": _ctx.tab == 'health',
            class: _normalizeClass(_ctx.tab == 'health' ? 'page-bar-toggle-s' : ''),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setTab('health')))
          }, [
            _cache[22] || (_cache[22] = _createStaticVNode("<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-4dc487f8><rect x=\"2\" y=\"3\" width=\"20\" height=\"14\" rx=\"2\" data-v-4dc487f8></rect><path d=\"M8 21h8M12 17v4M6 10h3l2-3 2 6 2-3h3\" data-v-4dc487f8></path></svg><em class=\"ft-label\" data-v-4dc487f8><i class=\"ft-long\" data-v-4dc487f8>Process health</i><i class=\"ft-short\" data-v-4dc487f8>Health</i></em>", 2)),
            (_ctx.suggestions.length)
              ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.suggestions.length), 1))
              : _createCommentVNode("", true)
          ], 10, _hoisted_6),
          (_ctx.isTeamHubAdmin)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                role: "tab",
                "aria-selected": _ctx.tab == 'company',
                class: _normalizeClass(_ctx.tab == 'company' ? 'page-bar-toggle-s' : ''),
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setTab('company')))
              }, [...(_cache[23] || (_cache[23] = [
                _createElementVNode("svg", {
                  xmlns: "http://www.w3.org/2000/svg",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round"
                }, [
                  _createElementVNode("path", { d: "M3 21h18M5 21V7l7-4 7 4v14M9 21v-6h6v6M9 10h.01M15 10h.01" })
                ], -1),
                _createElementVNode("em", { class: "ft-label" }, [
                  _createTextVNode("Company"),
                  _createElementVNode("i", { class: "ft-long" }, " health")
                ], -1)
              ]))], 10, _hoisted_8))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.$store.state.routeLoaded ? 'slide-up view' : 'hide')
    }, [
      _createElementVNode("div", _hoisted_9, [
        _withDirectives(_createElementVNode("div", null, [
          _createElementVNode("section", _hoisted_10, [
            _cache[27] || (_cache[27] = _createElementVNode("h2", { id: "fs-start-title" }, "What do you want to make?", -1)),
            _cache[28] || (_cache[28] = _createElementVNode("p", null, "Describe it and the Forge opens the right tool with your words filled in, or pick one below.", -1)),
            _createElementVNode("div", _hoisted_11, [
              _withDirectives(_createElementVNode("textarea", {
                id: "fs-start-text",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.startText) = $event)),
                rows: "2",
                maxlength: "8000",
                "aria-label": "What do you want to make?",
                placeholder: "e.g. Rocks for the sales team this quarter · a Powerlist for closing the shop · a BBQ at Cincinnati on Friday",
                onKeydown: _cache[4] || (_cache[4] = _withKeys(_withModifiers(($event: any) => (_ctx.routeStart()), ["exact","prevent"]), ["enter"]))
              }, null, 544), [
                [_vModelText, _ctx.startText]
              ]),
              _createElementVNode("button", {
                type: "button",
                class: "ai-btn",
                disabled: _ctx.routing || !_ctx.startText.trim(),
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.routeStart()))
              }, _toDisplayString(_ctx.routing ? 'Finding it…' : 'Start'), 9, _hoisted_12)
            ]),
            (_ctx.startError)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_ctx.startError), 1))
              : _createCommentVNode("", true),
            (_ctx.startNote)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(_ctx.startNote), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _cache[25] || (_cache[25] = _createElementVNode("span", { class: "fs-group-label" }, "Playbook", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.playbookTools, (t) => {
                  return (_openBlock(), _createElementBlock("button", {
                    key: t.key,
                    type: "button",
                    class: "fs-tool",
                    onClick: ($event: any) => (_ctx.openPlaybook(t.key))
                  }, _toDisplayString(t.label), 9, _hoisted_17))
                }), 128))
              ]),
              (_ctx.teamTools.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                    _cache[26] || (_cache[26] = _createElementVNode("span", { class: "fs-group-label" }, "Team", -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.teamTools, (t) => {
                      return (_openBlock(), _createElementBlock("button", {
                        key: t.key,
                        type: "button",
                        class: "fs-tool",
                        onClick: ($event: any) => (_ctx.openTeam(t.key))
                      }, _toDisplayString(t.label), 9, _hoisted_19))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          (_openBlock(), _createBlock(_component_ai_create_node, {
            ref: "createNode",
            inline: true,
            key: _ctx.createKey,
            "node-type": _ctx.createType,
            "initial-note": _ctx.createNote,
            onClose: _cache[6] || (_cache[6] = ($event: any) => (_ctx.createKey++))
          }, null, 8, ["node-type", "initial-note"])),
          _createVNode(_component_forge_team, { ref: "forgeTeam" }, null, 512),
          _createVNode(_component_forge_notetaker),
          (_ctx.videoJobs.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                _cache[31] || (_cache[31] = _createElementVNode("div", { class: "ai-drafts-title" }, "My AI Captures", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.videoJobs, (job) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: job.id,
                    "data-job-id": job.id,
                    class: "ai-drafts-row"
                  }, [
                    _createElementVNode("span", {
                      class: _normalizeClass(["ai-drafts-chip", 'ai-drafts-' + job.status])
                    }, _toDisplayString(job.status == 'processing' ? (job.stage || 'Processing') + '...' : job.status == 'complete' ? 'Ready to review' : job.status == 'recording' ? 'Recording — not yet submitted' : job.status == 'handoff' ? (job.stage ? job.stage + '...' : job.handoffToMe ? 'Sent to you — to build' : 'Waiting for ' + (job.handoffTo || 'the builder')) : job.status == 'discarded' ? 'Recording discarded' : job.status == 'consumed' ? (job.nodeType == 'meeting' ? (job.hasMeetingNotes ? 'Meeting notes saved' : 'Recording discarded') : job.targetSlug ? 'Update applied' : _ctx.jobTypeName(job.nodeType) + ' created') : 'Failed'), 3),
                    _createElementVNode("span", _hoisted_22, [
                      _createTextVNode(_toDisplayString(job.draftName || (job.nodeType == 'meeting' ? 'Meeting notes' : job.sourceLabel == 'photos' ? 'Photo capture' : job.sourceLabel == 'documents' ? 'Document upload' : job.sourceLabel == 'files' ? 'Photos + documents' : job.sourceLabel == 'recording' ? 'Screen recording' : 'Uploaded video')) + " ", 1),
                      (job.targetSlug)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(job.mode == 'extend' ? 'adds to an existing ' + (job.nodeType == 'timeline' ? 'value engine' : job.nodeType || 'process') : 'updates an existing process'), 1))
                        : (job.handoffFrom)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(job.handoffToMe ? 'from ' + job.handoffFrom : 'sent to ' + job.handoffTo), 1))
                          : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("span", _hoisted_25, _toDisplayString(new Date(job.created).toLocaleString(undefined, { dateStyle: 'short', timeStyle: 'short' })), 1),
                    (job.nodeType == 'meeting' || ['complete', 'processing', 'handoff'].includes(job.status))
                      ? (_openBlock(), _createBlock(_component_router_link, {
                          key: 0,
                          to: '/ai-review/' + job.id,
                          class: "ai-drafts-link"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(job.status == 'complete' ? 'Review' : job.status == 'handoff' ? 'Open' : 'View'), 1)
                          ]),
                          _: 2
                        }, 1032, ["to"]))
                      : (job.status == 'consumed' && job.createdSlug)
                        ? (_openBlock(), _createBlock(_component_router_link, {
                            key: 1,
                            to: '/edit-process/' + job.createdSlug,
                            class: "ai-drafts-link"
                          }, {
                            default: _withCtx(() => [...(_cache[29] || (_cache[29] = [
                              _createTextVNode("Open", -1)
                            ]))]),
                            _: 1
                          }, 8, ["to"]))
                        : (_openBlock(), _createElementBlock("span", {
                            key: 2,
                            class: "ai-drafts-err",
                            title: job.error
                          }, " ", 8, _hoisted_26)),
                    (job.status == 'consumed' && job.videoSlug)
                      ? (_openBlock(), _createBlock(_component_router_link, {
                          key: 3,
                          to: '/playbook/' + job.videoSlug,
                          class: "ai-drafts-link"
                        }, {
                          default: _withCtx(() => [...(_cache[30] || (_cache[30] = [
                            _createTextVNode("Video", -1)
                          ]))]),
                          _: 1
                        }, 8, ["to"]))
                      : _createCommentVNode("", true)
                  ], 8, _hoisted_21))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (_ctx.myVoice?.available && (_ctx.myVoice.enrolled || _ctx.videoJobs.some(j => j.nodeType == 'meeting')))
            ? (_openBlock(), _createElementBlock("section", _hoisted_27, [
                _cache[32] || (_cache[32] = _createElementVNode("div", {
                  id: "ai-voice-title",
                  class: "ai-drafts-title"
                }, "My voice", -1)),
                (_ctx.myVoice.enrolled)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_28, [
                      _createTextVNode("Your voice is remembered, so meeting recordings put your name on it automatically. Saved " + _toDisplayString(new Date(_ctx.myVoice.updatedAt).toLocaleDateString(undefined, { dateStyle: 'medium' })) + " from " + _toDisplayString(Math.round(_ctx.myVoice.sampleSeconds)) + " seconds of speech. It is a voiceprint (numbers), not audio, and only you can change or remove it. ", 1),
                      _createElementVNode("button", {
                        type: "button",
                        class: "ai-voice-forget",
                        disabled: _ctx.voiceBusy,
                        onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.forgetVoice && _ctx.forgetVoice(...args)))
                      }, "Forget my voice", 8, _hoisted_29)
                    ]))
                  : (_openBlock(), _createElementBlock("p", _hoisted_30, "Not saved. To have meeting recordings name you automatically, open a processed meeting, go to Transcript & speakers, name your voice and tick “Remember my voice”.")),
                (_ctx.voiceMessage)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_31, _toDisplayString(_ctx.voiceMessage), 1))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ], 512), [
          [_vShow, _ctx.tab == 'make']
        ]),
        (_ctx.tab == 'company' && _ctx.isTeamHubAdmin)
          ? (_openBlock(), _createBlock(_component_company_health, { key: 0 }))
          : _createCommentVNode("", true),
        _withDirectives(_createElementVNode("div", null, [
          _createElementVNode("section", _hoisted_32, [
            (_ctx.health)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass(["fh-ring", 'fh-ring-' + _ctx.healthClass(_ctx.health.current)])
                }, [
                  (_openBlock(), _createElementBlock("svg", _hoisted_33, [
                    _cache[33] || (_cache[33] = _createElementVNode("circle", {
                      cx: "36",
                      cy: "36",
                      r: "31",
                      class: "fh-ring-track"
                    }, null, -1)),
                    _createElementVNode("circle", {
                      cx: "36",
                      cy: "36",
                      r: "31",
                      class: "fh-ring-fill",
                      "stroke-dasharray": _ctx.ringDash(_ctx.health.current)
                    }, null, 8, _hoisted_34)
                  ])),
                  _createElementVNode("span", null, _toDisplayString(_ctx.health.current), 1)
                ], 2))
              : (_openBlock(), _createElementBlock("div", _hoisted_35, [...(_cache[34] || (_cache[34] = [
                  _createElementVNode("span", null, "–", -1)
                ]))])),
            _createElementVNode("div", _hoisted_36, [
              _cache[35] || (_cache[35] = _createElementVNode("div", { class: "fh-label" }, "Process health", -1)),
              (_ctx.health)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("div", _hoisted_37, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.health.current), 1),
                      (_ctx.health.projected > _ctx.health.current)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_38, "↑ " + _toDisplayString(_ctx.health.projected) + " after fixes", 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_39, [
                      _createTextVNode(_toDisplayString(_ctx.health.count) + " process" + _toDisplayString(_ctx.health.count == 1 ? '' : 'es') + " · " + _toDisplayString(_ctx.suggestions.length) + " flagged", 1),
                      (_ctx.lastChecked)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode(" · last checked " + _toDisplayString(_ctx.lastChecked), 1)
                          ], 64))
                        : _createCommentVNode("", true)
                    ])
                  ], 64))
                : (_openBlock(), _createElementBlock("div", _hoisted_40, "Not checked yet. Check processes to score every live process."))
            ]),
            _createElementVNode("div", _hoisted_41, [
              (_ctx.isTrainer)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 0,
                    to: "/ai-training",
                    class: "fh-rules",
                    title: "Set the rules the Forge follows"
                  }, {
                    default: _withCtx(() => [
                      _cache[36] || (_cache[36] = _createElementVNode("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        stroke: "currentColor",
                        "stroke-width": "2",
                        "stroke-linecap": "round"
                      }, [
                        _createElementVNode("path", { d: "M4 21v-7M4 10V3M12 21v-9M12 8V3M20 21v-5M20 12V3M1 14h6M9 8h6M17 16h6" })
                      ], -1)),
                      _cache[37] || (_cache[37] = _createTextVNode(" Company rules ", -1)),
                      _createElementVNode("span", null, _toDisplayString(_ctx.trainingRules.length), 1)
                    ]),
                    _: 1
                  }))
                : (_ctx.trainingRules.length)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 1,
                      class: "fh-rules fh-rules-static",
                      title: _ctx.trainingRules.join('\n')
                    }, [
                      _cache[38] || (_cache[38] = _createElementVNode("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        stroke: "currentColor",
                        "stroke-width": "2",
                        "stroke-linecap": "round"
                      }, [
                        _createElementVNode("path", { d: "M4 21v-7M4 10V3M12 21v-9M12 8V3M20 21v-5M20 12V3M1 14h6M9 8h6M17 16h6" })
                      ], -1)),
                      _cache[39] || (_cache[39] = _createTextVNode(" Company rules ", -1)),
                      _createElementVNode("span", null, _toDisplayString(_ctx.trainingRules.length), 1)
                    ], 8, _hoisted_42))
                  : _createCommentVNode("", true),
              (_ctx.competitiveAllowed)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 2,
                    to: "/competitive-analysis",
                    class: "fh-rules",
                    title: "IronBook's weekly market research"
                  }, {
                    default: _withCtx(() => [...(_cache[40] || (_cache[40] = [
                      _createElementVNode("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        stroke: "currentColor",
                        "stroke-width": "2",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                      }, [
                        _createElementVNode("path", { d: "M3 3v18h18M7 15l4-4 3 3 5-6" })
                      ], -1),
                      _createTextVNode(" Competitive analysis ", -1)
                    ]))]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.usageAllowed)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 3,
                    to: "/usage",
                    class: "fh-rules",
                    title: "How many people use IronBook, per company"
                  }, {
                    default: _withCtx(() => [...(_cache[41] || (_cache[41] = [
                      _createElementVNode("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        stroke: "currentColor",
                        "stroke-width": "2",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                      }, [
                        _createElementVNode("path", { d: "M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75" })
                      ], -1),
                      _createTextVNode(" IronBook usage ", -1)
                    ]))]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (!_ctx.confirmData)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 4,
                    class: _normalizeClass(["ai-btn", _ctx.running ? 'disable-button' : '']),
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.askConfirm()))
                  }, [
                    _cache[42] || (_cache[42] = _createElementVNode("svg", {
                      xmlns: "http://www.w3.org/2000/svg",
                      width: "14",
                      height: "14",
                      viewBox: "0 0 24 24",
                      fill: "none",
                      stroke: "currentColor",
                      "stroke-width": "2.5",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round"
                    }, [
                      _createElementVNode("path", { d: "M21 12a9 9 0 1 1-2.64-6.36M21 3v6h-6" })
                    ], -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.running ? 'Checking...' : (_ctx.health || _ctx.suggestions.length ? 'Check again' : 'Check Processes')), 1)
                  ], 2))
                : (_openBlock(), _createElementBlock("div", _hoisted_43, [
                    _createElementVNode("div", _hoisted_44, [
                      _cache[43] || (_cache[43] = _createTextVNode(" Check ", -1)),
                      _createElementVNode("strong", null, _toDisplayString(_ctx.confirmData.count), 1),
                      _createTextVNode(" live process" + _toDisplayString(_ctx.confirmData.count == 1 ? '' : 'es') + "? ", 1),
                      _createElementVNode("span", _hoisted_45, "est. ~" + _toDisplayString(_ctx.confirmData.estMinutes) + " min", 1)
                    ]),
                    _createElementVNode("div", {
                      class: "ai-btn",
                      onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.startAnalysis()))
                    }, "Start"),
                    _createElementVNode("div", {
                      class: "ai-btn ai-btn-ghost",
                      onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.confirmData = null))
                    }, "Cancel")
                  ]))
            ]),
            (_ctx.usage && _ctx.isTrainer)
              ? (_openBlock(), _createElementBlock("div", _hoisted_46, _toDisplayString(_ctx.usage.calls) + " AI calls this month · ~$" + _toDisplayString(_ctx.usage.estCostUSD), 1))
              : _createCommentVNode("", true)
          ]),
          _cache[56] || (_cache[56] = _createElementVNode("p", { class: "fh-intro" }, "The Forge reads every live process, scores it, and flags gaps like missing owners, vague steps and missing safety checks. Each fix is saved as a draft. Nothing goes live without someone signing off.", -1)),
          (_ctx.teamGroups.length || _ctx.teamError)
            ? (_openBlock(), _createElementBlock("section", _hoisted_47, [
                _createElementVNode("div", _hoisted_48, [
                  _createElementVNode("h3", _hoisted_49, [
                    _cache[44] || (_cache[44] = _createTextVNode("From your team ", -1)),
                    _createElementVNode("span", _hoisted_50, _toDisplayString(_ctx.teamSuggestions.length), 1)
                  ]),
                  _createVNode(_component_router_link, {
                    to: "/review?type=Process%20Suggestions",
                    class: "ft-team-all"
                  }, {
                    default: _withCtx(() => [...(_cache[45] || (_cache[45] = [
                      _createTextVNode("All suggestions in Review", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                (_ctx.teamError)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_51, _toDisplayString(_ctx.teamError), 1))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.shownTeamGroups, (g) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: g.key,
                    class: "ft-team-row"
                  }, [
                    _createElementVNode("div", _hoisted_52, [
                      _createElementVNode("div", _hoisted_53, [
                        (g.first.Slug)
                          ? (_openBlock(), _createBlock(_component_router_link, {
                              key: 0,
                              to: '/playbook/' + g.first.Slug,
                              target: "_blank"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(g.first.NodeName || 'A playbook page'), 1)
                              ]),
                              _: 2
                            }, 1032, ["to"]))
                          : (_openBlock(), _createElementBlock("span", _hoisted_54, _toDisplayString(g.first.NodeName || 'No page given'), 1)),
                        (g.rows.length > 1)
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 2,
                              class: "ft-team-dup",
                              title: g.rows.map(r => r.User).join(', ')
                            }, _toDisplayString(g.rows.length) + " people suggested this", 9, _hoisted_55))
                          : _createCommentVNode("", true),
                        (g.first.ForgeStatus == 'drafted')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_56, "Forge draft ready"))
                          : (g.first.DraftPending)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_57, "draft pending"))
                            : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("p", _hoisted_58, _toDisplayString(g.first.Text), 1),
                      _createElementVNode("div", _hoisted_59, _toDisplayString(g.rows.map(r => r.User).filter((u, i, a) => a.indexOf(u) == i).join(', ')) + " · " + _toDisplayString(_ctx.shortDate(g.first.Date)), 1)
                    ]),
                    _createElementVNode("div", _hoisted_60, [
                      (g.first.CanDraft)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "ai-btn",
                            onClick: ($event: any) => (_ctx.openTeamSuggestion(g))
                          }, _toDisplayString(g.first.ForgeStatus == 'drafted' ? 'Open the draft' : 'Draft with the Forge'), 9, _hoisted_61))
                        : (_openBlock(), _createElementBlock("span", _hoisted_62, "Not a process: edit it by hand")),
                      _createElementVNode("a", {
                        class: "fh-dismiss",
                        onClick: _withModifiers(($event: any) => (_ctx.dismissTeamGroup(g)), ["prevent"])
                      }, "Dismiss", 8, _hoisted_63)
                    ])
                  ]))
                }), 128)),
                (_ctx.teamGroups.length > _ctx.teamShow)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 1,
                      class: "ft-team-more",
                      onClick: _cache[11] || (_cache[11] = _withModifiers(($event: any) => (_ctx.teamShow += 10), ["prevent"]))
                    }, "Show " + _toDisplayString(Math.min(10, _ctx.teamGroups.length - _ctx.teamShow)) + " more", 1))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (_ctx.teamOpen)
            ? (_openBlock(), _createBlock(_component_forge_suggestion_draft, {
                key: 1,
                suggestion: _ctx.teamOpen.first,
                onClose: _cache[12] || (_cache[12] = ($event: any) => (_ctx.teamOpen = null)),
                onDrafted: _cache[13] || (_cache[13] = id => _ctx.markTeam(id, 'drafted')),
                onSaved: _cache[14] || (_cache[14] = e => _ctx.teamSaved(e)),
                onDismissed: _cache[15] || (_cache[15] = () => { const g = _ctx.teamOpen; _ctx.teamOpen = null; _ctx.dismissTeamGroup(g); })
              }, null, 8, ["suggestion"]))
            : _createCommentVNode("", true),
          (_ctx.running && _ctx.run)
            ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                _createElementVNode("div", _hoisted_65, " Checking processes... " + _toDisplayString(_ctx.run.Completed) + " of " + _toDisplayString(_ctx.run.Total) + " complete ", 1),
                _createElementVNode("div", _hoisted_66, [
                  _createElementVNode("div", {
                    class: "ai-progress-bar",
                    style: _normalizeStyle({ width: _ctx.progressPercent + '%' })
                  }, null, 4)
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.run && _ctx.run.Status == 'error' && _ctx.run.Error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_67, _toDisplayString(_ctx.run.Error), 1))
            : _createCommentVNode("", true),
          (!_ctx.running && !_ctx.suggestions.length && _ctx.loaded)
            ? (_openBlock(), _createElementBlock("div", _hoisted_68, [...(_cache[46] || (_cache[46] = [
                _createElementVNode("p", null, "No open suggestions. Check processes to have the Forge review every live process.", -1)
              ]))]))
            : _createCommentVNode("", true),
          (_ctx.suggestions.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
                _createElementVNode("div", _hoisted_70, [
                  _cache[48] || (_cache[48] = _createElementVNode("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "16",
                    height: "16",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    "stroke-linecap": "round"
                  }, [
                    _createElementVNode("circle", {
                      cx: "11",
                      cy: "11",
                      r: "7"
                    }),
                    _createElementVNode("path", { d: "M21 21l-4.35-4.35" })
                  ], -1)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.search) = $event)),
                    type: "text",
                    placeholder: "Search flagged processes"
                  }, null, 512), [
                    [_vModelText, _ctx.search]
                  ]),
                  (_ctx.search)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_71, _toDisplayString(_ctx.filteredSuggestions.length) + " of " + _toDisplayString(_ctx.shownBeforeSearch.length), 1))
                    : _createCommentVNode("", true),
                  (_ctx.search)
                    ? (_openBlock(), _createElementBlock("svg", {
                        key: 1,
                        class: "ai-search-clear",
                        onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.search = '')),
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "14",
                        height: "14",
                        viewBox: "0 0 24 24",
                        fill: "currentColor"
                      }, [...(_cache[47] || (_cache[47] = [
                        _createElementVNode("path", { d: "M23 20.168l-8.185-8.187 8.185-8.174-2.832-2.807-8.182 8.179-8.176-8.179-2.81 2.81 8.186 8.196-8.186 8.184 2.81 2.81 8.203-8.192 8.18 8.192z" }, null, -1)
                      ]))]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_72, [
                  _createElementVNode("button", {
                    type: "button",
                    class: _normalizeClass({ on: _ctx.filter == 'all' }),
                    onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.filter = 'all'))
                  }, "All flagged (" + _toDisplayString(_ctx.suggestions.length) + ")", 3),
                  _createElementVNode("button", {
                    type: "button",
                    class: _normalizeClass({ on: _ctx.filter == 'critical' }),
                    onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.filter = 'critical'))
                  }, "Critical (" + _toDisplayString(_ctx.criticalCount) + ")", 3)
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.suggestions.length && !_ctx.filteredSuggestions.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_73, [
                (_ctx.search)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_74, "No flagged processes match \"" + _toDisplayString(_ctx.search) + "\".", 1))
                  : (_openBlock(), _createElementBlock("p", _hoisted_75, "No processes with critical issues."))
              ]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredSuggestions, (s) => {
            return (_openBlock(), _createElementBlock("div", {
              key: s.ID,
              class: _normalizeClass(["ai-card", { 'ai-card-open': _ctx.expanded == s.ID }])
            }, [
              _createElementVNode("div", {
                class: "ai-card-top",
                onClick: ($event: any) => (_ctx.toggleExpand(s.ID))
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass(["ai-score", _ctx.scoreClass(s.Score)])
                }, _toDisplayString(s.Score), 3),
                _createElementVNode("div", _hoisted_77, [
                  _createElementVNode("div", _hoisted_78, [
                    _createTextVNode(_toDisplayString(s.NodeName) + " ", 1),
                    (s.NeedsApproval)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_79, "draft pending"))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_80, [
                    (s.ProcessOwnerNames)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_81, _toDisplayString(s.ProcessOwnerNames), 1))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sevCounts(s), (c) => {
                      return (_openBlock(), _createElementBlock("span", {
                        key: c.sev,
                        class: _normalizeClass(["fh-count", 'fh-count-' + c.sev])
                      }, _toDisplayString(c.n) + " " + _toDisplayString(c.label.toLowerCase()), 3))
                    }), 128))
                  ])
                ]),
                (s.ImprovedScore && s.ImprovedScore > s.Score)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "fh-lift",
                      title: 'About ' + s.ImprovedScore + ' after the fix'
                    }, [
                      _cache[49] || (_cache[49] = _createElementVNode("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "11",
                        height: "11",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        stroke: "currentColor",
                        "stroke-width": "2.5",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                      }, [
                        _createElementVNode("path", { d: "M7 17L17 7M8 7h9v9" })
                      ], -1)),
                      _createTextVNode("+" + _toDisplayString(s.ImprovedScore - s.Score), 1)
                    ], 8, _hoisted_82))
                  : _createCommentVNode("", true),
                _createElementVNode("div", {
                  class: _normalizeClass(["ai-expand-arrow", _ctx.expanded == s.ID ? 'ai-expanded' : ''])
                }, [...(_cache[50] || (_cache[50] = [
                  _createElementVNode("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "14",
                    height: "14",
                    viewBox: "0 0 24 24",
                    fill: "currentColor"
                  }, [
                    _createElementVNode("path", { d: "M0 7.33l2.829-2.83 9.175 9.339 9.167-9.339 2.829 2.83-11.996 12.17z" })
                  ], -1)
                ]))], 2)
              ], 8, _hoisted_76),
              (_ctx.expanded == s.ID)
                ? (_openBlock(), _createElementBlock("div", _hoisted_83, [
                    _createElementVNode("p", _hoisted_84, _toDisplayString(s.Summary), 1),
                    _createElementVNode("div", _hoisted_85, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.parseIssues(s.IssuesJSON), (issue, i) => {
                        return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
                          _createElementVNode("span", {
                            class: _normalizeClass(["fh-sev", 'fh-sev-' + issue.severity])
                          }, _toDisplayString(_ctx.sevLabel(issue.severity)), 3),
                          _createElementVNode("span", {
                            class: "fh-issue",
                            title: issue.recommendation
                          }, [
                            _createTextVNode(_toDisplayString(issue.issue), 1),
                            (issue.recommendation)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_87, _toDisplayString(issue.recommendation), 1))
                              : _createCommentVNode("", true)
                          ], 8, _hoisted_86)
                        ], 64))
                      }), 128))
                    ]),
                    _createElementVNode("div", _hoisted_88, [
                      (s.ImprovedScore && s.ImprovedScore > s.Score)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_89, "Fixing all of this takes it to about " + _toDisplayString(s.ImprovedScore) + ".", 1))
                        : _createCommentVNode("", true),
                      _cache[53] || (_cache[53] = _createElementVNode("span", { style: {"flex":"1"} }, null, -1)),
                      _createElementVNode("a", {
                        class: "fh-dismiss",
                        onClick: _withModifiers(($event: any) => (_ctx.dismiss(s)), ["prevent"])
                      }, "Dismiss", 8, _hoisted_90),
                      _createVNode(_component_router_link, {
                        class: "ai-btn ai-btn-ghost",
                        to: '/playbook/' + s.Slug,
                        target: "_blank"
                      }, {
                        default: _withCtx(() => [...(_cache[51] || (_cache[51] = [
                          _createTextVNode("Open process", -1)
                        ]))]),
                        _: 1
                      }, 8, ["to"]),
                      (s.DraftProcessJSON)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 1,
                            class: "ai-btn",
                            onClick: ($event: any) => (_ctx.fixing = _ctx.fixing == s.ID ? null : s.ID)
                          }, [
                            _cache[52] || (_cache[52] = _createElementVNode("svg", {
                              xmlns: "http://www.w3.org/2000/svg",
                              width: "13",
                              height: "13",
                              viewBox: "0 0 24 24",
                              fill: "currentColor"
                            }, [
                              _createElementVNode("path", {
                                "fill-rule": "evenodd",
                                d: "M12 23c-4.4 0-8-3.1-8-7.5 0-3.3 2-5.6 3.6-7.4.4-.4 1.1-.1 1.1.5 0 1.3.6 2.6 1.6 3.2C10.1 7.7 11.6 4 15 1.2c.4-.3 1 0 1 .5-.1 2.6.9 4.5 2.2 6.4C19.3 9.8 20 11.6 20 15.5 20 19.9 16.4 23 12 23zm0-2c1.9 0 3.3-1.3 3.3-3.1 0-1.6-.9-2.7-2.1-3.9-.3-.3-.8-.1-.8.3-.1 1-.6 1.8-1.3 2.2-.1-1.1-.5-2-1.1-2.6-.3-.3-.8-.1-.8.3-.3 1.3-1.5 2.2-1.5 3.7C7.7 19.7 9.8 21 12 21z"
                              })
                            ], -1)),
                            _createTextVNode(" " + _toDisplayString(_ctx.fixing == s.ID ? 'Hide the fix' : 'Fix in the Forge'), 1)
                          ], 8, _hoisted_91))
                        : _createCommentVNode("", true)
                    ]),
                    (_ctx.fixing == s.ID)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_92, [
                          _createVNode(_component_forge_compare, {
                            current: _ctx.parseItems(s.CurrentProcessJSON),
                            draft: _ctx.parseItems(s.DraftProcessJSON),
                            changes: _ctx.parseJSON(s.ChangesJSON)
                          }, {
                            "draft-label": _withCtx(() => [
                              (s.ImprovedScore)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_93, _toDisplayString(s.Score) + " → " + _toDisplayString(s.ImprovedScore), 1))
                                : _createCommentVNode("", true),
                              (s.SuggestedName && s.SuggestedName != s.NodeName)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_94, "— \"" + _toDisplayString(s.SuggestedName) + "\"", 1))
                                : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1032, ["current", "draft", "changes"]),
                          _createElementVNode("div", _hoisted_95, [
                            _cache[55] || (_cache[55] = _createElementVNode("div", { style: {"flex":"1"} }, null, -1)),
                            _createElementVNode("div", {
                              class: _normalizeClass(["ai-btn", _ctx.applying == s.ID ? 'disable-button' : '']),
                              onClick: ($event: any) => (_ctx.apply(s))
                            }, [
                              _cache[54] || (_cache[54] = _createElementVNode("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                width: "14",
                                height: "14",
                                viewBox: "0 0 24 24",
                                fill: "currentColor"
                              }, [
                                _createElementVNode("path", { d: "M20.285 2l-11.285 11.567-5.286-5.011-3.714 3.716 9 8.728 15-15.285z" })
                              ], -1)),
                              _createTextVNode(" " + _toDisplayString(_ctx.applying == s.ID ? 'Saving...' : 'Save as Draft for Approval'), 1)
                            ], 10, _hoisted_96)
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ], 2))
          }), 128))
        ], 512), [
          [_vShow, _ctx.tab == 'health']
        ]),
        _createElementVNode("p", _hoisted_97, [
          _createElementVNode("a", {
            href: "#",
            onClick: _cache[20] || (_cache[20] = _withModifiers(($event: any) => (_ctx.$emit('layout', 'new')), ["prevent"]))
          }, "Try the new Forge layout")
        ])
      ])
    ], 2)
  ]))
}